module.exports = __webpack_public_path__ + "img/arrow-right-w.52833734.svg";